export default __webpack_public_path__ + "f5041b67f2f5971665e83da7a2b8ac80.ttf";